/* PreSleep buy box. Vanilla custom element, no dependencies.
   Reads flavor + pack data that Liquid computed from live product data
   (never does price math itself), so what we show is what checkout charges. */
(function () {
  'use strict';
  if (customElements.get('ps-buy-box')) return;

  function fill(tpl, map) {
    return (tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }

  class PsBuyBox extends HTMLElement {
    connectedCallback() {
      var data = this.querySelector('[data-ps-flavors]');
      try { this.flavors = JSON.parse(data ? data.textContent : '[]'); } catch (e) { this.flavors = []; }
      var s = this.querySelector('[data-ps-strings]');
      this.str = s ? s.dataset : {};
      this.slides = Array.from(this.querySelectorAll('.ps-gal__slide'));
      this.slide = 0;
      this.pack = 0;
      this.sub = !!this.querySelector('[data-ps-sub]');
      this.flavor = this.flavors.find(function (f) { return f.available; }) || this.flavors[0] || null;
      this.bind();
      this.render();
      this.initSticky();
    }

    $(sel) { return this.querySelector(sel); }
    $$(sel) { return Array.from(this.querySelectorAll(sel)); }

    bind() {
      var self = this;
      this.$$('[data-ps-flavor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var f = self.flavors.find(function (x) { return x.key === btn.dataset.psFlavor; });
          if (!f || !f.available) return;
          self.flavor = f;
          var fi = self.slides.indexOf(self.$('[data-ps-flavor-img]'));
          self.setSlide(fi > -1 ? fi : 0);
          self.render();
        });
      });
      this.$$('[data-ps-pack]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.pack = parseInt(btn.dataset.psPack, 10) || 0; self.render(); });
      });
      var sub = this.$('[data-ps-sub]');
      if (sub) sub.addEventListener('click', function () { self.sub = true; self.render(); });
      var once = this.$('[data-ps-onetime]');
      if (once) once.addEventListener('click', function () { self.sub = false; self.render(); });

      var n = this.slides.length;
      this.$$('[data-ps-prev]').forEach(function (b) { b.addEventListener('click', function () { self.setSlide((self.slide - 1 + n) % n); }); });
      this.$$('[data-ps-next]').forEach(function (b) { b.addEventListener('click', function () { self.setSlide((self.slide + 1) % n); }); });
      this.$$('[data-ps-goto]').forEach(function (b) { b.addEventListener('click', function () { self.setSlide(parseInt(b.dataset.psGoto, 10) || 0); }); });
      var stage = this.$('[data-ps-stage]');
      if (stage) {
        var x0 = null;
        stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) self.setSlide((self.slide + (dx < 0 ? 1 : -1) + n) % n);
          x0 = null;
        }, { passive: true });
        stage.tabIndex = 0;
        stage.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') self.setSlide((self.slide - 1 + n) % n);
          if (e.key === 'ArrowRight') self.setSlide((self.slide + 1) % n);
        });
      }

      var form = this.$('[data-ps-form]');
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); self.addToCart(); });
    }

    setSlide(i) {
      this.slide = i;
      this.slides.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
      this.$$('[data-ps-goto]').forEach(function (el) {
        var on = parseInt(el.dataset.psGoto, 10) === i;
        el.classList.toggle('is-active', on);
        if (el.hasAttribute('aria-selected')) el.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var c = this.$('[data-ps-counter]');
      if (c) c.textContent = (i + 1) + ' / ' + this.slides.length;
    }

    current() {
      var f = this.flavor;
      if (!f || !f.packs || !f.packs.length) return null;
      return f.packs[Math.min(this.pack, f.packs.length - 1)];
    }

    render() {
      var self = this, f = this.flavor, pk = this.current();
      if (!f) return;
      var str = this.str;

      // Flavor-driven fields
      this.$$('[data-ps-flavor]').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.psFlavor === f.key ? 'true' : 'false'); });
      var set = function (sel, v) { var el = self.$(sel); if (el && v != null) el.textContent = v; };
      set('[data-ps-title]', f.title);
      set('[data-ps-flavor-name]', f.label);
      var img = this.$('[data-ps-flavor-img]');
      if (img && f.image && img.getAttribute('src') !== f.image) {
        img.src = f.image;
        img.srcset = f.image600 + ' 600w, ' + f.image900 + ' 900w, ' + f.image + ' 1200w';
        img.alt = f.alt;
      }
      var th = this.$('[data-ps-flavor-thumb]');
      if (th && f.thumb) th.src = f.thumb;

      // Pack tiles show the price for the current purchase type
      this.$$('[data-ps-pack]').forEach(function (b, i) {
        var p = f.packs[i];
        b.setAttribute('aria-checked', i === self.pack ? 'true' : 'false');
        if (!p) return;
        var price = self.sub ? p.sub : p.once;
        var night = self.sub ? p.nightSub : p.nightOnce;
        var pe = b.querySelector('[data-ps-pack-price]'); if (pe) pe.textContent = price;
        var ne = b.querySelector('[data-ps-pack-night]'); if (ne) ne.textContent = fill(str.night, { price: night });
      });

      // Subscription card + perks
      var map = pk ? { supply: fill(str.supply, { nights: pk.nights }), cadence: pk.cadence, nights: pk.nights, pct: f.pct } : {};
      var subEl = this.$('[data-ps-sub]');
      if (subEl) { subEl.classList.toggle('is-on', this.sub); subEl.setAttribute('aria-pressed', this.sub ? 'true' : 'false'); }
      set('[data-ps-sub-off]', fill(str.subOff, { pct: f.pct }));
      if (pk) { set('[data-ps-sub-was]', pk.list); set('[data-ps-sub-now]', pk.sub); }
      this.$$('[data-ps-perk]').forEach(function (el) { el.textContent = fill(el.dataset.psPerk, map); });

      // One-time link
      var once = this.$('[data-ps-onetime]');
      if (once && pk) {
        var tpl = pk.onceTemplate || str.onetime;
        once.textContent = fill(this.sub ? tpl : (str.onetimeSelected || tpl), { price: pk.once, pct: '', qty: pk.qty });
        once.setAttribute('aria-pressed', this.sub ? 'false' : 'true');
      }

      // Form inputs
      var v = this.$('[data-ps-variant]'); if (v) v.value = f.variant;
      var q = this.$('[data-ps-qty]'); if (q && pk) q.value = pk.qty;
      var plan = this.$('[data-ps-plan]'); if (plan) plan.value = (this.sub && f.plan) ? f.plan : '';
      var btn = this.$('[data-ps-atc]');
      if (btn) { btn.disabled = !f.available; btn.textContent = f.available ? btn.dataset.label : btn.dataset.soldout; }

      this.renderSticky();
    }

    renderSticky() {
      var st = this.$('[data-ps-sticky]'); if (!st) return;
      var f = this.flavor, pk = this.current(); if (!f) return;
      var t = st.querySelector('[data-ps-sticky-title]'); if (t) t.textContent = f.title;
      var th = st.querySelector('[data-ps-sticky-thumb]'); if (th && f.thumb) th.src = f.thumb;
      var pr = st.querySelector('[data-ps-sticky-price]');
      if (pr && pk) {
        var now = this.sub ? pk.sub : pk.once;
        pr.textContent = pr.dataset.template ? fill(pr.dataset.template, { price: now, pct: f.pct })
          : this.sub ? (pk.sub + (pr.dataset.suffix ? ' · ' + pr.dataset.suffix : '')) : pk.once;
      }
    }

    initSticky() {
      var st = this.$('[data-ps-sticky]'), btn = this.$('[data-ps-atc]'), self = this;
      if (!st || !btn) return;
      document.body.appendChild(st); // escape any transformed ancestor so position:fixed is viewport-relative
      var show = function (on) { st.classList.toggle('is-visible', on); st.setAttribute('aria-hidden', on ? 'false' : 'true'); var b = st.querySelector('[data-ps-sticky-atc]'); if (b) b.tabIndex = on ? 0 : -1; };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { show(!e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(btn);
      }
      var sb = st.querySelector('[data-ps-sticky-atc]');
      if (sb) sb.addEventListener('click', function () {
        if (st.dataset.action === 'scroll') { self.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
        self.addToCart();
      });
    }

    addToCart() {
      var f = this.flavor, pk = this.current(), self = this;
      var btn = this.$('[data-ps-atc]'), err = this.$('[data-ps-error]');
      if (!f || !f.available || (btn && btn.disabled && btn.dataset.busy)) return;
      var item = { id: Number(f.variant), quantity: pk ? pk.qty : 1 };
      if (this.sub && f.plan) item.selling_plan = Number(f.plan);
      if (err) err.textContent = '';
      if (btn) { btn.dataset.busy = '1'; btn.disabled = true; btn.textContent = btn.dataset.adding || btn.dataset.label; }
      var code = (!this.sub && pk && pk.code) ? pk.code : '';
      var pre = code ? fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}) : Promise.resolve();
      pre.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
      }).then(function (res) {
        return res.json().then(function (d) { if (!res.ok) throw { soft: true, d: d }; return d; });
      }).then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      }).then(function (cart) {
        self.done(btn);
        self.cartUpdated(cart);
      }).catch(function (e) {
        self.done(btn);
        if (e && e.soft) {
          if (err) err.textContent = (e.d && (e.d.description || e.d.message)) || self.str.error || '';
        } else {
          var form = self.$('[data-ps-form]');
          if (form) HTMLFormElement.prototype.submit.call(form); // network failure: native post so the sale isn't lost
        }
      });
    }

    done(btn) {
      if (!btn) return;
      delete btn.dataset.busy;
      btn.disabled = !(this.flavor && this.flavor.available);
      btn.textContent = btn.disabled ? btn.dataset.soldout : btn.dataset.label;
    }

    cartUpdated(cart) {
      // UpCart listens to fetch and exposes an opener; fall back to the theme cart page.
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('ps:cart-updated', { bubbles: true, detail: { cart: cart } }));
      document.querySelectorAll('[data-ps-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count; el.hidden = !cart.item_count;
      });
      if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return; }
      if (typeof window.openCart === 'function') { window.openCart(); return; }
      window.location.href = '/cart';
    }
  }
  customElements.define('ps-buy-box', PsBuyBox);

  // Keep #offer jumps clear of the pinned store header: measure it and expose the height as a CSS variable.
  function setStickyOffset() {
    var h = document.querySelector('.ps-hdr');
    var sec = h && h.closest('.shopify-section, [id^="shopify-section"]');
    var pinned = sec && /sticky|fixed/.test(getComputedStyle(sec).position);
    var px = pinned ? Math.round(h.getBoundingClientRect().height) + 8 : 8;
    document.documentElement.style.setProperty('--ps-sticky-offset', px + 'px');
  }
  setStickyOffset();
  window.addEventListener('resize', setStickyOffset, { passive: true });
  document.addEventListener('DOMContentLoaded', setStickyOffset);

  // Carry the landing page's query string (UTMs, fbclid) onto marked links.
  document.addEventListener('DOMContentLoaded', function () {
    var q = window.location.search;
    if (!q) return;
    document.querySelectorAll('a[data-ps-keep-query]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || /^mailto:|^tel:/.test(href)) return;
      a.setAttribute('href', href + (href.indexOf('?') > -1 ? '&' + q.slice(1) : q));
    });
  });
})();
